// Additional polyfills
import "custom-event-polyfill";
import "url-polyfill";

import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import globals from "./globals";
import Popper from "popper.js";
import registerFilters from "./filters/registerFilters";
import store from "./store";
import useAuth from "./auth/useAuth";
import hasValue from "@/lib/hasValue";

import { ApplicationInsights } from '@microsoft/applicationinsights-web'

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;
Vue.config.productionTip = false;
Vue.use(BootstrapVue);

if (window.__env.insights_config) {
  const appInsights = new ApplicationInsights({ config: {
    connectionString: window.__env.insights_config.connectionString
  }});
  if (window.__env.insights_config.connectionString) {
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
}

registerFilters();
useAuth();

// Global RTL flag
Vue.mixin({
  data: function() {
    return {
      ...globals(),
      filedValidationStatus: {}
    };
  },

  methods: {
    requiredFiled(key, filed) {
      this.$set(this.filedValidationStatus, key, hasValue(filed));
      return this.filedValidationStatus[key];
    },
    mustSameWith(key, filed1, filed2) {
      this.$set(this.filedValidationStatus, key, filed1 === filed2);
      return this.filedValidationStatus[key];
    },
    DisplaySaveSuccess() {
      this.$bvModal.msgBoxOk("Operation is successful");
    }
  },
  computed: {
    isModelValid() {
      return !this.hasModelError;
    },
    hasModelError() {
      return Object.values(this.filedValidationStatus).some(f => !f);
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
